export const MODAL_CONTENT_BREAST_CANCER = {
  EISINGER: `
Le score d'Eisinger prend en compte l'ensemble des antécédents familiaux d'une patiente. Il a été validé pour l'indication de **la consultation d'oncogénétique** et pour graduer le **risque de cancer du sein** en l'absence de mutation.

Interprétation du score d'Eisinger :

- **5 ou plus** : indication nécessaire et indispensable de la consultation d'oncogénétique
- **3 ou 4** : indication possible et recommandée de la consultation d'oncogénétique
- **1 ou 2** : la patiente n'est pas nécessairement orientée vers une consultation d'oncogénétique ; en revanche un maintien dans le parcours de dépistage organisé est primordial.
`,
};
